/**
 * Returns the public URL for a given path.
 *
 * @param {string} path - Path to convert to a public URL.
 * @returns {string} Converted public URL.
 */
export function getPublicUrl(path) {
    if (!path) return '';
    if (/^http/.test(path)) return path;
    if (/__mode=thumbnail_image/.test(path)) return `${location.protocol}//${location.host}` + path;
    return window.mtappVars.site.site_url.replace(/(https?:\/\/[^/]+).*/, '$1') + path;
}
